import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/JuanIS/JuanISServices.css';

function JuanISServices() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('All');

  const handleServiceClick = (service) => {
    switch (service) {
      case 'cor':
        navigate('/student/cor');
        break;
      case 'flowchart':
        navigate('/student/flowchart');
        break;
      case 'registration':
        navigate('/student/registration');
        break;
      case 'schedule':
        navigate('/student/schedule');
        break;
      case 'ote':
        navigate('/student/ote');
        break;
      case 'ledger':
        navigate('/student/ledger');
        break;
      case 'enrollment':
        navigate('/student/enrollment');
        break;
      case 'bills':
        navigate('/student/bills');
        break;
      default:
        break;
    }
  };

  const renderSection = (title, services) => {
    if (activeCategory !== 'All' && activeCategory !== title) return null;

    return (
      <section className="juanis-services-section">
        <h2>{title}</h2>
        <div className="juanis-services-grid">
          {services}
        </div>
      </section>
    );
  };

  const studentDocuments = (
    <div className="juanis-services-card" onClick={() => handleServiceClick('cor')} role="button" tabIndex={0}>
      <div className="juanis-services-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M20 6L9 17l-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2V12" strokeWidth="2"/>
        </svg>
      </div>
      <span>Certificate of Registration (COR)</span>
    </div>
  );

  const classOffers = (
    <>
      <div className="juanis-services-card" onClick={() => handleServiceClick('flowchart')} role="button" tabIndex={0}>
        <div className="juanis-services-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3 6h6m-6 6h6m-6 6h6m5-12h2m-2 6h2m-2 6h2m3-12h2m-2 6h2m-2 6h2" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Flowchart</span>
      </div>
      <div className="juanis-services-card" onClick={() => handleServiceClick('registration')} rolehbar tabIndex={0}>
        <div className="juanis-services-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" strokeWidth="2"/>
            <path d="M13 3h-2a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1z" strokeWidth="2"/>
            <path d="M9 12h6m-6 4h6" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Online Class Registration</span>
      </div>
    </>
  );

  const studentViews = (
    <>
      <div className="juanis-services-card" onClick={() => handleServiceClick('schedule')} role="button" tabIndex={0}>
        <div className="juanis-services-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
            <path d="M12 6v6l4 2" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Class Schedule</span>
      </div>
      <div className="juanis-services-card" onClick={() => handleServiceClick('ote')} role="button" tabIndex={0}>
        <div className="juanis-services-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 5h6" strokeWidth="2"/>
            <path d="M9 12h6m-6 4h6" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Online Teacher's Evaluation (OTE)</span>
      </div>
      <div className="juanis-services-card" onClick={() => handleServiceClick('ledger')} role="button" tabIndex={0}>
        <div className="juanis-services-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <rect x="2" y="3" width="20" height="18" rx="2" strokeWidth="2"/>
            <path d="M8 7h8m-8 5h8m-8 5h8" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Student Ledger</span>
      </div>
    </>
  );

  const applicationSubmission = (
    <div className="juanis-services-card" onClick={() => handleServiceClick('enrollment')} role="button" tabIndex={0}>
      <div className="juanis-services-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 4v16m8-8H4" strokeWidth="2" strokeLinecap="round"/>
          <path d="M16 8V6a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" strokeWidth="2"/>
        </svg>
      </div>
      <span>Enrollment</span>
    </div>
  );

  const otherServices = (
    <div className="juanis-services-card" onClick={() => handleServiceClick('bills')} role="button" tabIndex={0}>
      <div className="juanis-services-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M17 6V4a2 2 0 00-2-2H9a2 2 0 00-2 2v2m10 0H7m10 0v14a2 2 0 01-2 2H9a2 2 0 01-2-2V6h10z" strokeWidth="2"/>
          <path d="M10 11v6m4-6v6" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>
      <span>Pay Bills</span>
    </div>
  );

  return (
    <div className="juanis-services-content">
      <div className="juanis-services-nav">
        <button 
          className={`juanis-services-nav-button ${activeCategory === 'All' ? 'active' : ''}`}
          onClick={() => setActiveCategory('All')}
        >
          All
        </button>
        <button 
          className={`juanis-services-nav-button ${activeCategory === 'Student Documents' ? 'active' : ''}`}
          onClick={() => setActiveCategory('Student Documents')}
        >
          Student Documents
        </button>
        <button 
          className={`juanis-services-nav-button ${activeCategory === 'Class Offers' ? 'active' : ''}`}
          onClick={() => setActiveCategory('Class Offers')}
        >
          Class Offers
        </button>
        <button 
          className={`juanis-services-nav-button ${activeCategory === 'Student Views' ? 'active' : ''}`}
          onClick={() => setActiveCategory('Student Views')}
        >
          Student Views
        </button>
        <button 
          className={`juanis-services-nav-button ${activeCategory === 'Application & Submission' ? 'active' : ''}`}
          onClick={() => setActiveCategory('Application & Submission')}
        >
          Application & Submission
        </button>
        <button 
          className={`juanis-services-nav-button ${activeCategory === 'Other Services' ? 'active' : ''}`}
          onClick={() => setActiveCategory('Other Services')}
        >
          Other Services
        </button>
      </div>

      <div className="juanis-services-sections-container">
        {renderSection('Student Documents', studentDocuments)}
        {renderSection('Class Offers', classOffers)}
        {renderSection('Student Views', studentViews)}
        {renderSection('Application & Submission', applicationSubmission)}
        {renderSection('Other Services', otherServices)}
      </div>
    </div>
  );
}

export default JuanISServices;